<template>
  <div>
    <el-form>
      <el-row type="flex" justify="left" style="flex-wrap: wrap;align-items: flex-end">
        <el-col :span="6">
          <el-form-item label="日期（Data）">
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              end-placeholder="结束时间（Hora de fim）"
              range-separator="-"
              start-placeholder="开始时间（Hora de início）"
              type="daterange"
              value-format="yyyy-MM-dd"
              style="width: 95%" size="small"
              :picker-options="pickerOptions"
              @change="dateChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="大区（Região）">
            <el-select
              v-model="queryForm.params.regionIds"
              placeholder="请选择（Favor selecionar）"
              clearable filterable multiple
              style="width: 95%" size="small"
              collapse-tags
              @change="regionChangeOption"
            >
              <el-option
                v-for="item in regionList"
                :key="item.id"
                :label="item.zhName + '（' + item.puName + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="州（Estado）">
            <el-select
              v-model="queryForm.params.states"
              placeholder="请选择（Favor selecionar）"
              clearable filterable multiple
              :multiple-limit="50"
              collapse-tags
              style="width: 95%" size="small"
            >
              <el-option
                v-for="item in StateList"
                :key="item.id"
                :label="item.label"
                :value="item.label"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <div>
        <el-button type="primary" size="small" @click="search">查询（Consultar）</el-button>
        <el-button
          type="info" plain size="small"
          @click="reset"
        >重置（Resetar）</el-button>
        <el-button size="small" @click="exportAll">导出（Exportar）</el-button>
      </div>
    </el-form>

    <el-table
      ref="tableRef"
      size="small" max-height="600" border
      style="width: 100%;margin-top: 20px"
      :header-cell-style="{background: '#e1e1e1', color: '#000', 'font-size': '15px'}"
      :data="tableData"
      :span-method="mergeRow"
    >
      <el-table-column label="序号（No.）" width="80" align="center">
        <template slot-scope="scope">
          <span>{{ (queryForm.pageNumber - 1) * queryForm.pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in tableHeaderList"
        :key="index"
        align="center"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.cloWidth"
        :show-overflow-tooltip="false"
        :class-name="getColumnClass(index)"
      >
        <template slot-scope="scope">
          <!--
          'secondUnloadMissCount' ? 15
          'secondBagMissCount' ? 17
          'thirdUnloadMissCount' ? 24
          'thirdLoadMissCount' ? 26
          -->
          <div
            v-if="
              item.prop === 'secondUnloadMissCount' ||
                item.prop === 'secondBagMissCount' ||
                item.prop === 'thirdUnloadMissCount' ||
                item.prop === 'thirdLoadMissCount' ||
                item.prop === 'secondLoadMissCount'
            "
            style="color: #1990ff;cursor: pointer"
            @click="toDetail(scope.row, item.prop)"
          >
            {{ scope.row[item.prop] }}
          </div>
          <span v-else>{{ scope.row[item.prop] || scope.row[item.prop] === 0 ? scope.row[item.prop] : '--' }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div class="right">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="queryForm.pageNumber"
        :page-sizes="[10, 20, 50, 100, 500, 1000]"
        :page-size.sync="queryForm.pageSize"
        :total="total"
        background
        style="margin: 10px 0"
        @current-change="page"
        @size-change="search"
      />
    </div>
  </div>
</template>

<script>
import { getLgAreaListData, regionQueryList, sortingMissScanPage, sortingMissScanExport } from '@/api/orderApi';
import dayjs from 'dayjs';
import { goRWExportList } from '@/utils/goExportList.js';

export default {
  data() {
    return {
      timeValue: [],
      pickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.selectDate = minDate.getTime();
          if (maxDate) {
            this.selectDate = '';
          }
        },
        disabledDate: (time) => {
          if (this.selectDate !== '') {
            const one = 30 * 24 * 3600 * 1000;
            const minTime = this.selectDate - one;
            const maxTime = this.selectDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        }
      },
      queryForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          startDate: '',
          endDate: '',
          level: 2, // 分拣层级: 1 一级分拣, 2 二三级分拣
          regionIds: [],
          states: []
        }
      },
      regionList: [],
      StateList: [],
      total: 0,
      tableData: [],
      tableHeaderList: [
        // 日期
        { label: '日期（Data）', prop: 'dataDate', cloWidth: '170' },
        // 大区
        { label: '大区（Região）', prop: 'region1', cloWidth: '110' },
        // 州
        { label: '网点所属州（Estado de origem）', prop: 'state1', cloWidth: '110' },
        // 二级解封车漏扫vtag数
        { label: '二级解封车漏扫vtag数（L2 Vtag Perd.Descarroç）', prop: 'secondUnsealMissVtagCount', cloWidth: '200' },
        // 二级应解封车vtag数
        { label: '二级应解封车vtag数（L2 Vtag a Descarroç）', prop: 'secondShouldUnsealVtagCount', cloWidth: '170' },
        // 二级解封车漏扫率
        { label: '二级解封车漏扫率（L2 % Perd.Descarroç）', prop: 'secondUnsealMissRate', cloWidth: '170' },
        // 二级卸车漏扫数
        { label: '二级卸车漏扫数（L2 Perd.Descarga）', prop: 'secondUnloadMissCount', cloWidth: '150' },
        // 二级装车数
        { label: '二级装车数（L2 Cont.Carreg.）', prop: 'secondLoadCount', cloWidth: '127' },
        // 二级卸车漏扫率
        { label: '二级卸车漏扫率（L2 % Perd.Descarga）', prop: 'secondUnloadMissRate', cloWidth: '150' },
        // 二级集包漏扫数
        { label: '二级集包漏扫数（L2 Perd.Consol.）', prop: 'secondBagMissCount', cloWidth: '150' },
        // 二级装车数
        { label: '二级装车数（L2 Cont.Carreg.）', prop: 'secondLoadCount', cloWidth: '127' },
        // 二级集包漏扫率
        { label: '二级集包漏扫率（L2 % Perd.Consol.）', prop: 'secondBagMissRate', cloWidth: '150' },
        // 二级装车漏扫数
        { label: '二级装车漏扫数（L2 Perd.Carreg.）', prop: 'secondLoadMissCount', cloWidth: '150' },
        // 三级卸车或网点入库数
        { label: '三级卸车或网点入库数（L3 Descarga/Entrada）', prop: 'thirdUnloadOrSiteArrivalCount', cloWidth: '180' },
        // 二级装车漏扫率
        { label: '二级装车漏扫率（L2 % Perd.Carreg.）', prop: 'secondLoadMissRate', cloWidth: '140' },
        // 二级封车漏扫vtag数
        { label: '二级封车漏扫vtag数（L2 Vtag Perd.Encarroç）', prop: 'secondSealMissVtagCount', cloWidth: '160' },
        // 三级卸车或网点入库vtag数
        { label: '三级卸车或网点入库vtag数（L3 Vtag Descarga/Entrada）', prop: 'thirdUnloadOrSiteArrivalVtagCount', cloWidth: '220' },
        // 二级封车漏扫率
        { label: '二级封车漏扫率（L2 % Perd.Encarroç）', prop: 'secondSealMissRate', cloWidth: '150' },
        // 三级解封车漏扫数
        { label: '三级解封车漏扫数（L3 Perd.Descarroç）', prop: 'thirdUnsealMissVtagCount', cloWidth: '150' },
        // 三级应解封车数
        { label: '三级应解封车数（L3 a Descarroç）', prop: 'thirdShouldUnsealVtagCount', cloWidth: '140' },
        // 三级解封车漏扫率
        { label: '三级解封车漏扫率（L3 % Perd.Descarroç）', prop: 'thirdUnsealMissRate', cloWidth: '150' },
        // 三级卸车漏扫数
        { label: '三级卸车漏扫数（L3 Perd.Descarga）', prop: 'thirdUnloadMissCount', cloWidth: '150' },
        // 三级装车数
        { label: '三级装车数（L3 Cont.Carreg.）', prop: 'thirdLoadCount', cloWidth: '150' },
        // 三级卸车漏扫率
        { label: '三级卸车漏扫率（L3 % Perd.Descarga）', prop: 'thirdUnloadMissRate', cloWidth: '150' },
        // 三级装车漏扫数
        { label: '三级装车漏扫数（L3 Perd.Carreg.）', prop: 'thirdLoadMissCount', cloWidth: '150' },
        // 网点入库数
        { label: '网点入库数（Entrada Agência）', prop: 'siteArrivalCount', cloWidth: '130' },
        // 三级装车漏扫数
        { label: '三级装车漏扫率（L3 % Perd.Carreg.）', prop: 'thirdLoadMissRate', cloWidth: '150' },
        // 三级漏封车vtag数
        { label: '三级漏封车vtag数（L3 Vtag Perd.Encarroç）', prop: 'thirdSealMissVtagCount', cloWidth: '150' },
        // 网点入库vtag数
        { label: '网点入库vtag数（Vtag Entrada Agência）', prop: 'siteArrivalVtagCount', cloWidth: '150' },
        // 三级封车漏扫率
        { label: '三级封车漏扫率（L3 % Perd.Encarroç）', prop: 'thirdSealMissRate', cloWidth: '150' }
      ]
    };
  },
  created() {
    this.getRegion();
    this.getState();
  },
  methods: {
    toSearch() {
      this.defaultTime();
      this.search();
    },
    getColumnClass(index) {
      if (index > 2) {
        const groupIndex = Math.floor((index - 3) / 3);
        return groupIndex % 2 === 0 ? 'yellow-column' : 'blue-column';
      }
      return '';
    },
    search() {
      this.queryForm.pageNumber = 1;
      this.page();
    },
    page() {
      const queryForm = JSON.parse(JSON.stringify(this.queryForm));
      queryForm.params.level = 2;
      sortingMissScanPage(queryForm).then(res => {
        if (res.code === 200) {
          const tableData = res.data.records.map(item => {
            return {
              region1: item.region || '--',
              state1: item.state != null ? item.state : '--',
              ...item
            };
          });
          this.tableData = tableData;
          this.total = res.data.total;
        }
      });
    },
    mergeRow({ row, column, rowIndex, columnIndex }) {
      // 日期列（索引1）和大区列（索引2）的合并逻辑
      if (columnIndex === 1) { // 日期列
        // 查找相同日期连续出现的数量
        if (rowIndex === 0 || this.tableData[rowIndex].dataDate !== this.tableData[rowIndex - 1].dataDate) {
          // 这是新日期的第一行，计算该日期重复多少行
          let count = 1;
          const currentDataDate = this.tableData[rowIndex].dataDate;
          for (let i = rowIndex + 1; i < this.tableData.length; i++) {
            if (this.tableData[i].dataDate === currentDataDate) {
              count++;
            } else {
              break;
            }
          }
          return {
            rowspan: count,
            colspan: 1
          };
        } else {
          // 不是第一个相同日期的行，不需要显示
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      } else if (columnIndex === 2) { // 大区列
        // 在同一日期内，检查是否与上一行的大区相同
        const currentDataDate = this.tableData[rowIndex].dataDate;
        let sameDateStartIndex = rowIndex;
        let sameDateEndIndex = rowIndex;
        // 找到当前日期范围的开始和结束
        for (let i = rowIndex; i >= 0 && this.tableData[i].dataDate === currentDataDate; i--) {
          sameDateStartIndex = i;
        }
        for (let i = rowIndex; i < this.tableData.length && this.tableData[i].dataDate === currentDataDate; i++) {
          sameDateEndIndex = i;
        }
        // 在当前日期范围内，检查是否为相同大区的第一个
        const currentRegion = this.tableData[rowIndex].region;
        let isSameRegionStart = true;
        for (let i = rowIndex - 1; i >= sameDateStartIndex; i--) {
          if (this.tableData[i].region === currentRegion) {
            isSameRegionStart = false;
            break;
          }
        }
        if (isSameRegionStart) {
          // 计算相同大区在同一天内的数量
          let count = 1;
          for (let i = rowIndex + 1; i <= sameDateEndIndex; i++) {
            if (this.tableData[i].region === currentRegion) {
              count++;
            } else {
              break;
            }
          }
          return {
            rowspan: count,
            colspan: 1
          };
        } else {
          // 不是同一大区的第一个，隐藏
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
      // 其他列不合并
      return {
        rowspan: 1,
        colspan: 1
      };
    },
    exportAll() {
      if (this.tableData.length <= 0) {
        this.$message.warning('列表暂无数据，无法导出（A lista não tem dados e não pode ser exportada）');
      } else {
        sortingMissScanExport(this.queryForm.params).then(res => {
          if (res.code === 200) {
            goRWExportList(this);
          }
        });
      }
    },
    reset() {
      this.queryForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          startDate: '',
          endDate: '',
          level: 2, // 分拣层级: 1 一级分拣, 2 二三级分拣
          regionIds: [],
          states: []
        }
      };
      this.defaultTime();
      this.search();
    },
    defaultTime() {
      // 前一天
      const yesterday = dayjs().subtract(1, 'day').format('YYYY-MM-DD');
      this.timeValue = [yesterday, yesterday];
      this.queryForm.params.startDate = yesterday;
      this.queryForm.params.endDate = yesterday;
    },
    dateChange(val) {
      if (val === null) {
        this.timeValue = [];
        return;
      }
      this.queryForm.params.startDate = val[0];
      this.queryForm.params.endDate = val[1];
    },
    // 大区
    getRegion() {
      regionQueryList('').then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    // 州
    getState() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    },
    // 大区联动州
    regionChangeOption(newVal) {
      this.queryForm.params.states = [];
      if (!newVal || newVal.length === 0 || this.regionList.length === 0) {
        this.StateList = [];
        this.getState();
        return;
      }
      const allStates = [];
      newVal.forEach(regionId => {
        const selectedRegion = this.regionList.find(item => item.id === regionId);
        if (selectedRegion && Array.isArray(selectedRegion.states)) {
          selectedRegion.sites.forEach(state => {
            if (!allStates.some(s => s.label === state.state)) {
              allStates.push({
                id: state.id,
                label: state.state
              });
            }
          });
          this.StateList = allStates;
        }
      });
    },

    // 打开明细
    toDetail(row, type) {
      // dataType  数据类型: 15-二级卸车漏扫数, 17-二级集包漏扫数, 24-三级卸车数, 26-三级装车漏扫数
      const typeVal = type === 'secondUnloadMissCount' ? 15 : type === 'secondBagMissCount' ? 17 : type === 'secondLoadMissCount' ? 18 : type === 'thirdUnloadMissCount' ? 24 : type === 'thirdLoadMissCount' ? 26 : null;
      let regionIds = [];
      let states = [];
      let dataDate = [];
      const currentRegionId = row.regionId;
      const currentState = row.state;
      if (row.state === '总计(Total)') {
        regionIds = this.queryForm.params.regionIds;
        states = this.queryForm.params.states;
        dataDate = this.timeValue;
      } else if (currentState === '大区总计(Total do Distrito)') {
        regionIds = [currentRegionId];
        states = this.queryForm.params.states;
        dataDate = [row.dataDate, row.dataDate];
      } else {
        // 普通行：当前行数据
        regionIds = currentRegionId ? [currentRegionId] : [];
        states = currentState && currentState !== '总计(Total)' && currentState !== '大区总计(Total do Distrito)' ? [currentState] : [];
        dataDate = [row.dataDate, row.dataDate];
      }
      // 去除重复值
      regionIds = [...new Set(regionIds)];
      states = [...new Set(states)];

      this.$emit('parentMethod', dataDate[0], dataDate[1], typeVal, regionIds, states);
    }
  }
};
</script>

<style lang="scss" scoped>
.right{
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
::v-deep .el-table th.blue-column {
  background-color: #e5f6fd !important;
}
::v-deep .el-table th.yellow-column {
  background-color: #fbe1be !important;
}
</style>
